const USER_PROPS = `
id
`;

const LINE_ITEM_PROPS = `
productId
variantId
quantity
name
sku
label
url
price
totalPrice
formattedTotalPrice
publishedProduct {
  name
  id
  url
  image {
    url
  }
}
`;

const ADDRESS_PROPS = `
  title
  firstname
  lastname
  company
  country
  county
  address1
  address2
  city
  postcode
  tel
  company
`;

const CART_DATA_DEFAULT_RESULT_PROPS = `
    id
    created
    updated
    formattedCreated
    formattedUpdated
    user {
      ${USER_PROPS}
    }
    shippingAddress {
      ${ADDRESS_PROPS}
    }
    billingAddress {
      ${ADDRESS_PROPS}
    }
    currency
    total
    formattedTotal
    completed
    lineItems {
        ${LINE_ITEM_PROPS}
    }
`;

export { LINE_ITEM_PROPS, CART_DATA_DEFAULT_RESULT_PROPS };
